import { API_URL } from '@aibees/shared/constants';
import { delay } from '@aibees/shared/utils';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import { addAuthTokenInterceptor } from '../interceptors/add-auth-token-interceptor';
import { applyCustomApiUrlInterceptor } from '../interceptors/apply-custom-api-url-interceptor';
import { errorHandlerInterceptor } from '../interceptors/error-handler-interceptor';
import { getRefreshTokenInterceptor } from '../interceptors/get-refresh-token-interceptor';
import type { QueryDelayOptions } from '../types';

const instance = axios.create({
  baseURL: API_URL,
});

addAuthTokenInterceptor(instance);
getRefreshTokenInterceptor(instance);
errorHandlerInterceptor(instance);
applyCustomApiUrlInterceptor(instance);

export default async (config: AxiosRequestConfig & QueryDelayOptions) => {
  if (config.delay) await delay(config.delay);
  const result = await instance(config);
  return result.data;
};
